import { request } from '@umijs/max';
import { authRequest } from './request';

type ApiResponse<T> = {
  success: boolean;
  code: string;
  message: string;
  data: T;
};

export type AuthCurrentUser = {
  userId: string;
  username?: string;
  userNickname?: string;
  email?: string;
  mobile?: string;
  roleCodes?: string[];
  permissions?: string[];
  menuPaths?: string[];
  lastLoginTime?: string;
  mustChangePassword?: number;
};

export type AuthMenu = {
  menuId: string;
  parentId?: string;
  menuName?: string;
  routePath?: string;
  componentPath?: string;
  icon?: string;
  menuType?: number;
  orderNum?: number;
  perms?: string;
};

export type LoginRequest = {
  username: string;
  password: string;
};

export type LoginResponse = {
  token: string;
  currentUser: AuthCurrentUser;
};

export async function loginByPassword(data: LoginRequest) {
  return request<ApiResponse<LoginResponse>>('/api/auth/login', {
    method: 'POST',
    data,
    skipErrorHandler: true,
  });
}

export async function queryCurrentUser(token?: string) {
  const response = await authRequest<ApiResponse<AuthCurrentUser>>('/api/auth/current-user', {
    method: 'GET',
  }, token);
  return response.data;
}

export async function queryCurrentMenus(token?: string) {
  const response = await authRequest<ApiResponse<AuthMenu[]>>('/api/auth/current-menus', {
    method: 'GET',
  }, token);
  return response.data;
}

export async function logoutRequest(token?: string) {
  const response = await authRequest<ApiResponse<null>>('/api/auth/logout', {
    method: 'POST',
  }, token);
  return response.data;
}
